import BaseModal from './BaseModal'
import ConfirmationModal from './ConfirmationModal'
import ConfirmDeleteModal from './ConfirmDeleteModal'
import InformationModal from './InformationModal'
import LoginModal from './LoginModal'
import PropertiesModal from './PropertiesModal'
import QueryChooseModal from './QueryChooseModal'
import ShareModal from './ShareModal'
import GeneratedKeywordsModal from './GeneratedKeywordsModal'
import TreeViewModal from './TreeViewModal'
import UserSettingsModal from './UserSettingsModal'

export {
  BaseModal,
  ConfirmationModal,
  ConfirmDeleteModal,
  InformationModal,
  LoginModal,
  PropertiesModal,
  QueryChooseModal,
  ShareModal,
  GeneratedKeywordsModal,
  TreeViewModal,
  UserSettingsModal
}



// WEBPACK FOOTER //
// ./src/components/modals/index.js